import React, { useState, useEffect } from 'react';
import api from '../configuracion/config';
import { format, parseISO } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.css';
import 'alertifyjs/build/css/themes/default.css';
import { estiloAlertify } from '../Funciones';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBroom,
  faFileArrowDown,
  faFileExcel,
  faFilePdf,
  faFilter,
  faMagnifyingGlass,
} from '@fortawesome/free-solid-svg-icons';
import './Filtro.css';

const XLSX = require('xlsx');

function Filtro() {
  const [sedes, setSedes] = useState([]);
  const [anotaciones, setAnotaciones] = useState([]);

  const [formulario, setFormData] = useState({
    tmeHora: '',
    dteFecha: '',
    dteFecha2: '',
    strAsunto: '',
    intIdSede: -1,
    strAnotacion: '',
    strUsuario: '',
  });

  const cargarSedes = async () => {
    await api
      .post('/Sedes')
      .then((response) => {
        setSedes(response.data);
      })
      .catch((error) => {
        console.error('Error al obtener las sedes:', error);
      });
  };

  const cargarFiltro = async () => {
    try {
      const filters = {};

      if (formulario.tmeHora) filters.tmeHora = formulario.tmeHora;

      if (formulario.dteFecha && formulario.dteFecha2) {
        filters.dteFecha = new Date(formulario.dteFecha);
        filters.dteFecha2 = new Date(formulario.dteFecha2);
      }

      if (formulario.strAsunto) filters.strAsunto = formulario.strAsunto;

      if (formulario.intIdSede !== -1 && formulario.intIdSede !== '-1')
        filters.intIdSede = formulario.intIdSede;

      if (formulario.strAnotacion)
        filters.strAnotacion = formulario.strAnotacion;

      if (formulario.strUsuario) filters.strUsuario = formulario.strUsuario;

      if (Object.keys(filters).length > 0) {
        const response = await api.post('/informes', filters);
        setAnotaciones(response.data);
      } else {
        //alert('Seleccione al menos un campo para realizar alguna Busqueda');
      }
    } catch (error) {}
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    const selectedDate = new Date(value);
    const currentDate = new Date(); // Obtiene la fecha actual

    // Compara la fecha seleccionada con la fecha actual
    if (
      (name === 'dteFecha' && selectedDate > currentDate) ||
      (name === 'dteFecha2' && selectedDate > currentDate)
    ) {
      alertify.error('No puedes seleccionar una fecha futura');
      estiloAlertify(0);
    } else {
      setFormData({ ...formulario, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formulario.dteFecha === '' && formulario.dteFecha2 !== '') {
      alertify.error('Debe Seleccionar Primero la Fecha Inicial');
      estiloAlertify(0);
      return;
    } else if (formulario.dteFecha2 === '' && formulario.dteFecha !== '') {
      alertify.error('Debe Seleccionar la Fecha Final');
      estiloAlertify(0);
      return;
    } else if (new Date(formulario.dteFecha) > new Date(formulario.dteFecha2)) {
      alertify.error(
        'La fecha Inicial debe ser menor o igual a la Fecha Final'
      );
      estiloAlertify(0);
      return;
    }
    cargarFiltro();
  };

  const limpiarFormulario = () => {
    setFormData({
      tmeHora: '',
      dteFecha: '',
      dteFecha2: '',
      strAsunto: '',
      intIdSede: -1,
      strAnotacion: '',
      strUsuario: '',
    });
    setAnotaciones([]);
  };

  useEffect(() => {
    cargarSedes();
  }, []);

  function exportToExcel() {
    if (anotaciones.length > 0) {
      alertify
        .confirm('¿Desea Exportar el informe a Excel?', async (e) => {
          if (e) {
            try {
              const dataForExcel = anotaciones.map((anotacion) => ({
                Fecha: format(
                  utcToZonedTime(parseISO(anotacion.dteFecha), 'UTC'),
                  'dd/MM/yyyy'
                ),
                Hora: format(
                  utcToZonedTime(parseISO(anotacion.tmeHora), 'UTC'),
                  'HH:mm:ss'
                ),
                Asunto: anotacion.strAsunto,
                Anotacion: anotacion.strAnotacion,
                Usuario: anotacion.strUsuario,
                Nombres: anotacion.strNombres,
                Sede: anotacion.strSede,
              }));

              const ws = XLSX.utils.json_to_sheet(dataForExcel);
              const wb = XLSX.utils.book_new();
              XLSX.utils.book_append_sheet(wb, ws, 'Tabla de Datos');
              const excelBuffer = XLSX.write(wb, {
                bookType: 'xlsx',
                type: 'array',
              });

              const fileName = 'Minuta.xlsx';

              // Verificar si el archivo ya existe
              const existingFile = new Blob([excelBuffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              });

              // Crear un enlace para descargar el archivo
              const a = document.createElement('a');
              a.href = URL.createObjectURL(existingFile);
              a.download = fileName;

              // Hacer clic en el enlace para descargar o reemplazar el archivo
              a.click();
            } catch (error) {
              alertify.error('Error al eliminar la minuta');
              estiloAlertify(0);
            }
          }
        })
        .set({
          labels: {
            ok: 'SI', // Etiqueta del botón OK
            cancel: 'NO', // Etiqueta del botón Cancelar
          },
          title: 'AVISO', // Título personalizado
        });
    } else {
      alertify.error(
        'la tabla Informes debe contener datos para poder exportar'
      );
      estiloAlertify(0);
    }
  }

  function exportToPDF() {
    if (anotaciones.length > 0) {
      alertify
        .confirm('¿Desea Exportar el informe a PDF?', async (e) => {
          if (e) {
            try {
              const doc = new jsPDF();
              const title = 'Informe Minuta';
              const date = 'Fecha: ' + new Date().toLocaleString();

              // Agregar título y fecha en la cabecera
              doc.setFontSize(16);
              doc.text(title, 15, 15);
              doc.setFontSize(10);
              doc.text(date, 15, 22);

              // Configura las columnas para la tabla
              const columns = [
                { title: 'Fecha', dataKey: 'Fecha' },
                { title: 'Hora', dataKey: 'Hora' },
                { title: 'Asunto', dataKey: 'Asunto' },
                { title: 'Anotacion', dataKey: 'Anotacion' },
                { title: 'Usuario', dataKey: 'Usuario' },
                { title: 'Nombres', dataKey: 'Nombres' },
                { title: 'Sede', dataKey: 'Sede' },
              ];
              doc.setFontSize(10);

              // Asegúrate de que dataForPDF sea un array de objetos
              const dataForPDF = anotaciones.map((anotacion) => ({
                Fecha: format(
                  utcToZonedTime(parseISO(anotacion.dteFecha), 'UTC'),
                  'dd/MM/yyyy'
                ),
                Hora: format(
                  utcToZonedTime(parseISO(anotacion.tmeHora), 'UTC'),
                  'HH:mm:ss'
                ),
                Asunto: anotacion.strAsunto,
                Anotacion: anotacion.strAnotacion,
                Usuario: anotacion.strUsuario,
                Nombres: anotacion.strNombres,
                Sede: anotacion.strSede,
              }));

              // Genera la tabla en el documento PDF
              doc.autoTable({
                columns,
                body: dataForPDF,
                head: [columns.map((column) => column.title)],
                startY: 30, // Ajusta la posición vertical de la tabla
                margin: { top: 20 }, // Ajusta el margen superior de la tabla
                tableLineColor: [0, 0, 0], // Color de las líneas de la tabla
                tableLineWidth: 0, // Grosor de las líneas de la tabla
                headStyles: {
                  fillColor: [204, 204, 204], // Color de fondo de la cabecera
                  textColor: [0, 0, 0], // Color de texto en la cabecera
                  fontSize: 8, // Tamaño de fuente en la cabecera
                },
                styles: {
                  fontSize: 8, // Tamaño de fuente para los datos de la tabla
                },
              });

              doc.save('Informe.pdf');
            } catch (error) {
              alertify.error('Error al eliminar la minuta');
              estiloAlertify(0);
            }
          }
        })
        .set({
          labels: {
            ok: 'SI', // Etiqueta del botón OK
            cancel: 'NO', // Etiqueta del botón Cancelar
          },
          title: 'AVISO', // Título personalizado
        });
    } else {
      alertify.error(
        'La tabla Informes debe contener datos para poder exportar'
      );
      estiloAlertify(0);
    }
  }

  const totalResultados = anotaciones.length;
  const hayFiltrosActivos = Object.values(formulario).some(
    (value) => value !== '' && value !== -1 && value !== '-1'
  );

  return (
    <div className="container-fluid mt-2 informes-page">
      <div className="row g-3">
        <div className="col-xl-3 col-lg-4">
          <form className="card shadow-sm border-0 informes-filter-card p-3">
            <div className="d-flex align-items-center justify-content-between mb-2">
              <h6 className="m-0 text-secondary">
                <FontAwesomeIcon icon={faFilter} className="me-2" />
                Filtros
              </h6>
              {hayFiltrosActivos && (
                <span className="badge rounded-pill text-bg-light border">
                  Activos
                </span>
              )}
            </div>

            <div className="form-group small">
              <label htmlFor="dteFecha">Fecha Inicial</label>
              <input
                type="date"
                name="dteFecha"
                id="dteFecha"
                className="form-control form-control-sm"
                value={formulario.dteFecha}
                onChange={handleChange}
                max={new Date().toISOString().split('T')[0]}
              />
            </div>

            <div className="form-group small mt-2">
              <label htmlFor="dteFecha2">Fecha Final</label>
              <input
                type="date"
                name="dteFecha2"
                id="dteFecha2"
                className="form-control form-control-sm"
                value={formulario.dteFecha2}
                onChange={handleChange}
                max={new Date().toISOString().split('T')[0]}
                required
              />
            </div>

            <div className="form-group small mt-2">
              <label htmlFor="tmeHora">Hora</label>
              <input
                type="time"
                name="tmeHora"
                id="tmeHora"
                className="form-control form-control-sm"
                value={formulario.tmeHora}
                onChange={handleChange}
              />
            </div>

            <div className="form-group small mt-2">
              <label htmlFor="strAsunto">Asunto</label>
              <input
                type="text"
                name="strAsunto"
                id="strAsunto"
                className="form-control form-control-sm"
                value={formulario.strAsunto}
                onChange={handleChange}
                placeholder="Ej. Novedad"
              />
            </div>

            <div className="form-group small mt-2">
              <label htmlFor="strUsuario">Usuario</label>
              <input
                type="text"
                name="strUsuario"
                id="strUsuario"
                className="form-control form-control-sm"
                value={formulario.strUsuario}
                onChange={handleChange}
                placeholder="Ej. jlopez"
              />
            </div>

            <div className="form-group small mt-2">
              <label htmlFor="intIdSede">Sede</label>
              <select
                name="intIdSede"
                id="intIdSede"
                className="form-control form-control-sm"
                value={formulario.intIdSede}
                onChange={handleChange}
              >
                <option value={-1}>Todas</option>
                {sedes.map((sede) => (
                  <option key={sede.intIdSede} value={sede.intIdSede}>
                    {sede.strSede}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group small mt-2">
              <label htmlFor="strAnotacion">Anotación</label>
              <textarea
                name="strAnotacion"
                id="strAnotacion"
                className="form-control form-control-sm"
                rows="3"
                value={formulario.strAnotacion}
                onChange={handleChange}
                placeholder="Palabras clave de la anotación"
              />
            </div>

            <div className="d-grid gap-2 mt-3">
              <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={handleSubmit}
              >
                <FontAwesomeIcon icon={faMagnifyingGlass} className="me-2" />
                Buscar
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={limpiarFormulario}
              >
                <FontAwesomeIcon icon={faBroom} className="me-2" />
                Limpiar filtros
              </button>
            </div>
          </form>
        </div>

        <div className="col-xl-9 col-lg-8">
          <div className="card shadow-sm border-0 p-3">
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-2">
              <div>
                <h5 className="card-title text-secondary mb-1">Informes</h5>
                <p className="small text-muted m-0">
                  {totalResultados} resultado{totalResultados === 1 ? '' : 's'}
                </p>
              </div>
              <div className="btn-group" style={{ zIndex: '2' }}>
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm"
                  data-bs-toggle="dropdown"
                >
                  <FontAwesomeIcon icon={faFileArrowDown} className="me-2" />
                  Exportar
                </button>
                <div className="dropdown-menu dropdown-menu-end">
                  <button className="dropdown-item" onClick={exportToExcel}>
                    <FontAwesomeIcon icon={faFileExcel} className="me-2 text-success" />
                    Exportar a Excel
                  </button>
                  <button className="dropdown-item" onClick={exportToPDF}>
                    <FontAwesomeIcon icon={faFilePdf} className="me-2 text-danger" />
                    Exportar a PDF
                  </button>
                </div>
              </div>
            </div>

            <div className="table-responsive informes-table-wrapper">
              <table className="table table-hover table-sm table-bordered align-middle mb-0">
                <thead className="table-light small">
                  <tr>
                    <th className="text-secondary col-1">Fecha</th>
                    <th className="text-secondary col-1">Hora</th>
                    <th className="text-secondary">Asunto</th>
                    <th className="text-secondary">Anotación</th>
                    <th className="text-secondary col-1 text-center">Usuario</th>
                    <th className="text-secondary text-center">Nombres</th>
                    <th className="text-secondary col-1 text-center">Sede</th>
                  </tr>
                </thead>
                <tbody className="small">
                  {anotaciones.length > 0 ? (
                    anotaciones.map((drw, index) => (
                      <tr key={index}>
                        <td>
                          {format(
                            utcToZonedTime(parseISO(drw.dteFecha), 'UTC'),
                            'dd/MM/yyyy'
                          )}
                        </td>
                        <td>
                          {format(
                            utcToZonedTime(parseISO(drw.tmeHora), 'UTC'),
                            'HH:mm:ss'
                          )}
                        </td>
                        <td>{drw.strAsunto}</td>
                        <td>{drw.strAnotacion}</td>
                        <td className="text-center">{drw.strUsuario}</td>
                        <td className="text-center">{drw.strNombres}</td>
                        <td className="text-center">{drw.strSede}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center text-muted py-4">
                        No hay resultados. Ajusta los filtros y presiona Buscar.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Filtro;
